export default __webpack_public_path__ + "static/media/icon-youtube.7d6960fb.svg";